module.exports = __webpack_public_path__ + "img/arrow-down-icon.e528af82.webp";